import { memo, useMemo } from 'react';

import { type Upload } from '@air/redux-uploader';
import { getAssetPreviewType } from '@air/utils-clips';

import { NameCellContent, type NameCellContentProps } from '~/components/TableView/NameCell/NameCellContent';
import { NoPreviewImage } from '~/components/UI/NoPreviewImage';
import { useUploadingData } from '~/components/Upload/hooks/useUploadingData';

export type UploadNameCellProps = {
  upload: Upload;
} & Pick<NameCellContentProps, 'imageSize'>;

/**
 * This component displays NameCell with data for upload
 */
export const UploadNameCell = memo(
  ({
    upload,
    upload: {
      apiUploadData: { ext, type },
    },
    ...props
  }: UploadNameCellProps) => {
    const { stateText } = useUploadingData(upload);

    const image = useMemo(
      () => (
        <NoPreviewImage
          type={getAssetPreviewType({ ext, type })}
          hideText={true}
          processing={true}
          ext={ext}
          size="small"
          color="gray"
        />
      ),
      [ext, type],
    );

    const title = useMemo(
      () => <div className="ml-3 truncate">{upload.apiUploadData.importedName}</div>,
      [upload.apiUploadData.importedName],
    );

    return (
      <NameCellContent image={image} {...props} title={title} disabled={true}>
        <p className="truncate text-14 text-grey-10">{stateText}</p>
      </NameCellContent>
    );
  },
);

UploadNameCell.displayName = 'UploadNameCell';
